module.exports = __webpack_public_path__ + "static/media/BOB.85106d8a.svg";